import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {Puzzle, PuzzleConstants} from './puzzle.js';
import {BoardColor, BoardObject} from './board-object.js';
import {FXPrefabs} from './fx-prefabs.js';
import {AxisY} from '../utils/Mathf.js';
import {WLUtils} from '../utils/WLUtils.js';

export class SpecialPower extends Component {
    static TypeName = 'special-power';
    static InheritProperties = true;

    @property.bool(false)
    bloatParent = false;

    @property.bool(false)
    canBeEjected = false;

    @property.bool(false)
    hideEyes = false;

    @property.bool(false)
    closeEyes = false;

    @property.string('')
    clickOnFX = '';

    init() {
        this.active = false;
    }

    start() {}

    update(dt: number) {}

    activate(puzzle: Puzzle, row: number, column: number) {
        if (this.clickOnFX && this.clickOnFX !== '') {
            const ang = column * (360 / PuzzleConstants.columnCount) + 180;
            const fxObject = FXPrefabs.instance.spawn(this.clickOnFX, null, false);
            fxObject.setPositionWorld(this.object.getPositionWorld([]));
            fxObject.rotateAxisAngleDegObject(AxisY, ang);
            fxObject.translateObject([0, 0, -1]);
            WLUtils.setActive(fxObject, true);
        }
        // default object just starts a chain reaction.
        puzzle.explode(row, column);
    }

    /**
     * @virtual
     */
    popped(puzzle: Puzzle, row: number, column: number) {}

    /**
     * called when this object is loaded into another
     * @virtual
     */
    loaded(newParent: BoardObject) {}

    /**
     * called when this object is placed on the board.
     * @virtual
     */
    placed(puzzle: Puzzle, newParent: BoardObject) {}

    /**
     * called when this object explodes on the board.
     * @virtual
     */
    explode(puzzle: Puzzle, row: number, column: number) {}
}
